// Central content + image config for the Birds Eye Views site.
// Swap these image URLs for the real drone photos when supplied.
export const LOGO =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_aerial-showcase-7/artifacts/n7deep80_BEV-Blue%20Logo-2000px.png";

export const IMAGES = {
  bannerPlaceholder:
    "https://images.unsplash.com/photo-1721424759830-e4b892acf1d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroForest:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_aerial-showcase-7/artifacts/2uz5l735_DJI_0441.webp",
  heroCoast:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_aerial-showcase-7/artifacts/kcqqqxlr_IMG_8561.webp",
  vistasBoat:
    "https://images.unsplash.com/photo-1521193698642-9810ddf4bff6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  agriHarvester:
    "https://images.unsplash.com/photo-1635174815612-fd9636f70146?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  agriSheep:
    "https://images.unsplash.com/photo-1759613484766-f2fd7a6eaf23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  transport4x4:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_aerial-showcase-7/artifacts/6lmu6nzk_DJI_0575.webp",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Vistas", id: "vistas" },
  { label: "Agriculture", id: "agriculture" },
  { label: "Transport", id: "transport" },
  { label: "Contact", id: "contact" },
  { label: "FPV", id: "fpv" },
];
